<!-- IE < 10 does not like giving a tbody a height.  The workaround here applies the scrolling to a wrapped <div>. -->
<!--[if lte IE 9]>
<div class="old_ie_wrapper">
  <!--<![endif]-->
  <div>
    <div>{{filter}}</div>
    <form (submit)="onSearchColumns(0)" [ngClass]="classform">
      @for (l of header; track l; let i = $index) {
        <span [ngClass]="getClassSearchHeader(i)">
          @if (l.searchtype != 'checkbox') {
            <input id="{{idtable}}-search-header-{{i}}" type="{{l.searchtype}}" placeholder="Search {{l.label}}" />
          }
          <!--<span *ngIf="l.searchtype == 'checkbox'">{{l.label}}:</span>-->
          @if (l.searchtype == 'checkbox') {
            <select id="{{idtable}}-search-header-{{i}}" title="{{l.label}}">
              <option>&nbsp;</option>
              <option>Yes</option>
              <option>No</option>
            </select>
          }
        </span>
      }
      <button class="button-search" type="submit" title="Search all columns with the content of textboxes">&nbsp;</button>
      <button class="button-reset" type="button" title="Reset all search" (click)="onResetList()">&nbsp;</button>
    </form>
    <table style="width: auto;" id="{{idtable}}" class="fixed_headers">
      <thead>
        <tr>
          @for (l of header; track l; let i = $index) {
            <th>
              {{l.label}}
            </th>
          }
          @if (isToShowEditButton()) {
            <th>&nbsp;</th>
          }
        </tr>
      </thead>

      <tbody>
        @for (d of data; track d; let r = $index) {
          <tr (click)="onRowSelect(d)">
            @for (l of header; track l; let c = $index) {
              <td [ngClass]="getClass(r, c)">
                @if (!l.checkbox) {
                  <span>{{getData(r, c)}}</span>
                }
                @if (l.checkbox) {
                  <span><input type="checkbox" [checked]="isInputChecked(r, c)" value="1" onclick="return false;" /></span>
                }
              </td>
            }
            @if (isToShowEditButton()) {
              <td><button type="button" class="btn btn-default" (click)="onRowEdit(d)">{{editLabel}}</button></td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
  <!--[if lte IE 9]>
</div>
<!--<![endif]-->
